import axios from "axios";
import {
  FETCH_CORTES_REQUEST,
  FETCH_CORTES_SUCCESS,
  FETCH_CORTES_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionCortesGet = () => async (dispatch) => {
  dispatch({ type: FETCH_CORTES_REQUEST });
  try {
    const res = await api.get("/cortes", { headers: authHeader() });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_CORTES_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar cortes";
    dispatch({ type: FETCH_CORTES_FAILURE, payload: { error: msg } });
  }
};

export const apiCortesInstance = api;
export { authHeader as authHeaderCortes };
